import { createApp } from 'vue';
import ImagePreview from './components/imagepreview';
import maxChoice from './components/maxchoices';
// import Map from './vue/Map.vue';
// import MapInput from './vue/MapInput.vue';
// import NominationForm from './vue/NominationForm';
// import MiniQuiz from './vue/MiniQuiz';
import MeasurementForm from './vue/Measurements/Form';
import MapInput from './vue/LandingPageMap.vue';

function getNextSiblings(elem, filter) {
	var sibs = [];
	while (elem = elem.nextSibling) {
		if (elem.nodeType === 3) continue; // text node
		if (!filter || filter(elem)) sibs.push(elem);
	}
	return sibs;
}

window.addEventListener('DOMContentLoaded', (event) => {
	setTimeout(() => {

	document.querySelectorAll('.vue-root').forEach((el) => {

		console.dir({el});

		//skip vue initialization if it has already been initialized
		if(el.querySelectorAll('main').length){
			return;
		}

		createApp({
			components: {
				'map-input': MapInput,
				// 'nomination-form': NominationForm,
				// 'mini-quiz': MiniQuiz,
				'measurement-form': MeasurementForm,
			},
		})
			.mount(el);
		// .component(Box)
		// .$mount(el);
	});

	const form15 = document.querySelector('.watermonsters-form');
	if (form15) {
		// const inputs = form15.querySelectorAll('input[type="file"]');
		// inputs.forEach((el) => {
		// 	new ImagePreview(el);
		// });

		const placeholdersForSelect = form15.querySelectorAll('.gf_placeholder');
		placeholdersForSelect.forEach((el) => {
			el.setAttribute('disabled', '');
		});

		const checkboxesWithMaxChoices = form15.querySelectorAll('[data-max-choices]');
		checkboxesWithMaxChoices.forEach((el) => {
			new maxChoice(el);
		});

		form15.addEventListener('hideOtherMapFormFields', evt => {
			const mapInput = form15.querySelector('.map input[type="hidden"]');
			const parent = mapInput.closest('.gfield');

			const elementsToHide = getNextSiblings(parent);
			elementsToHide.push(document.querySelector('.gform_footer'));

			elementsToHide.forEach(el => el.classList.add('hidden'));
			document.querySelector('#measured-notice').classList.remove('hidden');
		});

		form15.addEventListener('showOtherMapFormFields', evt => {
			const mapInput = form15.querySelector('.map input[type="hidden"]');
			const parent = mapInput.closest('.gfield');

			const elementsToHide = getNextSiblings(parent);
			elementsToHide.push(document.querySelector('.gform_footer'));

			elementsToHide.forEach(el => el.classList.remove('hidden'));
			document.querySelector('#measured-notice').classList.add('hidden');
		});

	}
	}, 1000);

	const meetgegevens = document.querySelector('[data-meetgegevens]');
	if (meetgegevens) {
		document.querySelector('input[type="submit"]')?.addEventListener('click', function(e) {
			const button = e.currentTarget;
			button.classList.add('button-disabled');
			button.value="Aan het verzenden..";

			setTimeout(() => {
				button.classList.remove('button-disabled');
				button.value="Verzenden";
			}, 10000);
		});
	}

	document.querySelectorAll('.page-template-watermonsters-landingspagina').forEach((elm) => {
		const map = elm.querySelector('#map');

		if(!map){
			return;
		}

		//check if marker is selected on homepage
		if(map.querySelector('map-input:not([previously-selected-marker-uuid=""])')){
			map.scrollIntoView({
				behavior: "smooth",
				block: "center",
			});
		}

	});

});
